import { render } from "./PageLayout.vue?vue&type=template&id=760a11e0"
import script from "./PageLayout.vue?vue&type=script&lang=ts"
export * from "./PageLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script